// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>32</span>&nbsp;&nbsp;Sing to God, you kingdoms of the earth;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;make music in praise of the Lord;<br> </p> </div></div>";
// Exports
module.exports = code;